import { getDateFactory } from '@/common/utils';
import { FC } from 'react';

import { SearchConsoleAnalyticsDatesDimension } from '@/modules/DomainsApi';

interface Props {
  value: SearchConsoleAnalyticsDatesDimension['key'];
}

export const DatesLabel: FC<Props> = ({ value }) => {
  return getDateFactory(new Date(value), 'Aug 16, 2018');
};
